var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDayMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_502",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.129
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2357",
    "data-name": "Rectangle 2357",
    width: 41.999,
    height: 42,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14621",
    "data-name": "Path 14621",
    d: "M8.668,0,7.7,3.667,4.869,1.136l.6,3.745L1.861,3.72,3.935,6.9.163,7.3,3.35,9.362.07,11.268l3.748.584L1.6,14.927l3.662-.991-.778,3.713,2.942-2.395.8,3.709,1.714-3.384,2.239,3.063.189-3.789,3.291,1.888L14.286,13.2l3.774.386-2.69-2.676,3.605-1.182L15.431,8.378l2.811-2.547-3.788.208,1.533-3.47L12.612,4.3,12.6.507,10.222,3.461Z",
    transform: "translate(-0.07)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.732,
    cy: 0.107,
    r: 0.837,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffff91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f22b00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14622",
    "data-name": "Path 14622",
    d: "M9.13,3.387,6.94.289,6.692,4.075,3.431,2.136,4.744,5.7.976,5.25,3.623,7.968,0,9.094,3.524,10.5.672,13l3.791-.149L2.875,16.3l3.4-1.678-.049,3.794L8.654,15.5l1.5,3.485,1.03-3.651,2.786,2.574-.544-3.755,3.592,1.219-2.024-3.209,3.777-.348L15.618,9.707l3.31-1.855-3.739-.643,2.269-3.04L13.781,5.1l.837-3.7L11.638,3.751,10.9.03Z",
    transform: "translate(0 -0.03)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.594,
    cy: 0.283,
    r: 0.736,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f25700"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14623",
    "data-name": "Path 14623",
    d: "M39.434,3.387l-2.19-3.1L37,4.075l-.924-.549c0,.028,0,.055,0,.082a8.624,8.624,0,0,0,8.624,8.624c.213,0,.423-.01.632-.025l-.028-.045,1.124-.1a8.562,8.562,0,0,0,2.007-.676L45.922,9.707l3.31-1.855-3.739-.643,2.269-3.04L44.085,5.1l.837-3.7L41.942,3.751,41.2.03Z",
    transform: "translate(-36.07 -0.03)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.416,
    cy: 0.439,
    r: 1.144,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffff57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f28000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14624",
    "data-name": "Path 14624",
    d: "M14.723,50.087A5.284,5.284,0,1,0,11,59.488a5.209,5.209,0,0,0,5.183,4.691c1.99,0,3.7-1.559,4.574-3.2a5.676,5.676,0,0,0,4.616,3.2c2.569,0,5.611-1.768,6.039-4.214a4.918,4.918,0,0,0,3.89-5.158c0-2.918-2.874-5.409-5.793-5.409a5.262,5.262,0,0,0-2.4.577,6.433,6.433,0,0,0-12.386.112",
    transform: "translate(-6.15 -45.338)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.671,
    cy: 0.383,
    r: 0.806,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3f3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58a9fb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2363",
    "data-name": "Rectangle 2363",
    width: 30.558,
    height: 26.511,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14626",
    "data-name": "Path 14626",
    d: "M71.6,46.883A12.229,12.229,0,0,0,85.957,60.9a3.654,3.654,0,0,0,.3-.938,4.918,4.918,0,0,0,3.89-5.158c0-2.918-2.874-5.409-5.793-5.409a5.262,5.262,0,0,0-2.4.577A6.431,6.431,0,0,0,71.6,46.883",
    transform: "translate(-71.434 -45.338)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.488,
    cy: 0.457,
    r: 0.962,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80befc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5410",
    "data-name": "Group 5410",
    transform: "translate(-1104 -571)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1104, 571)",
    filter: "url(#Ellipse_502)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_502-2",
    "data-name": "Ellipse 502",
    cx: 21,
    cy: 21,
    r: 21,
    transform: "translate(9 6)",
    fill: "#d2fffc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5409",
    "data-name": "Group 5409",
    transform: "translate(1113 577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5408",
    "data-name": "Group 5408",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5440",
    "data-name": "Group 5440",
    transform: "translate(5.72 7.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5427",
    "data-name": "Group 5427",
    transform: "translate(0.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5426",
    "data-name": "Group 5426",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2359",
    "data-name": "Rectangle 2359",
    width: 18.906,
    height: 18.963,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5429",
    "data-name": "Group 5429",
    transform: "translate(0 0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5428",
    "data-name": "Group 5428",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2360",
    "data-name": "Rectangle 2360",
    width: 18.928,
    height: 18.954,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5431",
    "data-name": "Group 5431",
    transform: "translate(5.766 0.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5430",
    "data-name": "Group 5430",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2361",
    "data-name": "Rectangle 2361",
    width: 13.162,
    height: 12.202,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5433",
    "data-name": "Group 5433",
    transform: "translate(0.983 7.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5432",
    "data-name": "Group 5432",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2362",
    "data-name": "Rectangle 2362",
    width: 29.152,
    height: 18.841,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5435",
    "data-name": "Group 5435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5434",
    "data-name": "Group 5434",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14625",
    "data-name": "Path 14625",
    d: "M18.537,59.577a5.776,5.776,0,0,1-4.575,2.8A5.633,5.633,0,0,1,8.4,57.651a5.707,5.707,0,1,1,3.872-10.465,6.857,6.857,0,0,1,12.867-.012,5.685,5.685,0,0,1,2.147-.419,6.462,6.462,0,0,1,4.275,1.721,5.634,5.634,0,0,1,1.94,4.112h0A5.368,5.368,0,0,1,29.547,58.1a5.31,5.31,0,0,1-2.339,3.022,7.6,7.6,0,0,1-4.055,1.26,5.856,5.856,0,0,1-4.615-2.8m.372-1.017c.82,1.546,2.487,2.991,4.243,2.975a6.764,6.764,0,0,0,3.59-1.12,4.35,4.35,0,0,0,2.032-2.744l.05-.288.287-.055c2.223-.429,3.533-2.314,3.546-4.743A4.791,4.791,0,0,0,30.994,49.1a5.621,5.621,0,0,0-3.705-1.5,4.839,4.839,0,0,0-2.209.531l-.456.233-.143-.491a6.01,6.01,0,0,0-11.572.1l-.168.621-.5-.4a4.861,4.861,0,1,0-3.424,8.649l.352.028.035.352a4.785,4.785,0,0,0,4.762,4.309c1.755.015,3.378-1.424,4.2-2.975l.373-.7Z",
    transform: "translate(-2.946 -35.87)",
    fill: "#4c99f1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5437",
    "data-name": "Group 5437",
    transform: "translate(11.419 7.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5436",
    "data-name": "Group 5436",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2364",
    "data-name": "Rectangle 2364",
    width: 18.716,
    height: 15.782,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5439",
    "data-name": "Group 5439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5438",
    "data-name": "Group 5438",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14627",
    "data-name": "Path 14627",
    d: "M89.028,48.474a6.462,6.462,0,0,0-4.275-1.721,5.684,5.684,0,0,0-2.147.419,6.854,6.854,0,0,0-10.488-3.147,12.09,12.09,0,0,0-.214,1.3,6.008,6.008,0,0,1,10.041,2.548l.143.491.455-.233a4.838,4.838,0,0,1,2.209-.531,5.621,5.621,0,0,1,3.705,1.5,4.791,4.791,0,0,1,1.664,3.486c-.013,2.429-1.323,4.314-3.546,4.743l-.287.055-.05.288a3.312,3.312,0,0,1-.412,1.1c.349-.05.693-.117,1.032-.2a4.141,4.141,0,0,0,.152-.475,5.368,5.368,0,0,0,3.956-5.514h0a5.633,5.633,0,0,0-1.94-4.112",
    transform: "translate(-60.41 -35.87)",
    fill: "#b8dafd"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayMode);
export default __webpack_public_path__ + "static/media/day-mode.42aab33eca139dc511f95ab65c1a00ac.svg";
export { ForwardRef as ReactComponent };